import React, { useMemo, useRef, useState } from "react";

import { Box } from "@chakra-ui/react";
import { ReactComponent as IconChevronDown } from "assets/icons/chevron-down-2.svg";
import { ReactComponent as IconSettings } from "assets/icons/settings.svg";
import { useIndividuals } from "contexts/individuals-context";
import {
  IMoreQuickActionItem, // IMoreQuickActionsProps,
  TQuickActionType,
} from "features/individuals/individual-details/more-quick-actions/types";
import {
  individualDetailsQuickActionBtnCss,
  moreQuickActionsDropDownPopUpMenuContentCss3,
} from "features/individuals/individual-details/styles";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "routes/constants";

import { DropDown } from "ui/dropdown";
import { IDropDownRef } from "ui/dropdown/types";
// import { TTableRowData } from "ui/table/types";
import { Paragraph3 } from "ui/typography";

import { INDIVIDUAL_ACCOUNT_NAME_IN_URL_SEPARATOR } from "../../consts";
import { DeactivateOdpAccess } from "./DeactivateOdpAccess";
import { ResendInviteModal } from "./ResendInviteModal";

// import { UpdateWithdrawalCharge } from "./UpdateWithdrawalCharge";

const textColorMap: Record<TQuickActionType, string> = {
  regular: "#1A202C",
  disabled: "#344054",
  danger: "#DC2626",
};
const DROP_DOWN_WIDTH = 240;

// interface INewMoreQuickActionsProps extends IMoreQuickActionsProps {
//   handleViewIndividualDetails: (individualRowData: TTableRowData) => void;
// }

export const MoreQuickActions = ({
  withdrawal,
  fee,
}: {
  withdrawal: number;
  fee: number;
}) => {
  const navigate = useNavigate();
  const { individualDetails } = useIndividuals();
  const email = individualDetails?.email;
  const employeeId = individualDetails?.employeeId;
  const accountName = individualDetails?.accountName as string;

  const { individualId: id } = useParams();
  const [isResendInviteModalOpen, setIsResendInviteModalOpen] = useState(false);
  // const [
  //   isUpdateWithdrawalChargeModalOpen,
  //   setIsUpdateWithdrawalChargeModalOpen,
  // ] = useState(false);
  const [isDeactivateOdpAccessModalOpen, setIsDeactivateOdpAccessModalOpen] =
    useState(false);
  const dropDownRef = useRef<IDropDownRef | null>(null);

  const handleToggleResendInviteModal = () =>
    setIsResendInviteModalOpen(!isResendInviteModalOpen);
  // const handleToggleUpdateWithdrawalChargeModal = () =>
  //   setIsUpdateWithdrawalChargeModalOpen(!isUpdateWithdrawalChargeModalOpen);
  const handleToggleDeactivateOdpAccessModal = () =>
    setIsDeactivateOdpAccessModalOpen(!isDeactivateOdpAccessModalOpen);

  const handleToggleDropDown = () => {
    if (!dropDownRef.current) return;
    dropDownRef.current.handleToggleDropdown();
  };

  const quickActions: IMoreQuickActionItem[] = useMemo(() => {
    return [
      {
        label: "View Withdrawal History",
        isDisabled: false,
        handleQuickActionItemClick: () => {
          handleToggleDropDown();
          navigate(
            `${ROUTES.INDIVIDUALS_PAGE}/on-demand-pay/${employeeId}/${accountName.replace(/ /g, INDIVIDUAL_ACCOUNT_NAME_IN_URL_SEPARATOR)}/view-withdrawal-history/${withdrawal}/${fee}`
          );
        },
        type: "disabled",
      },
      {
        label: "Resend Invite",
        isDisabled: false,
        handleQuickActionItemClick: () => {
          handleToggleDropDown();
          handleToggleResendInviteModal();
        },
        type: "regular",
      },
      // {
      //   label: "Update Withdrawal Charge",
      //   isDisabled: false,
      //   handleQuickActionItemClick: () => {
      //     handleToggleDropDown();
      //     handleToggleUpdateWithdrawalChargeModal();
      //   },
      //   type: "regular",
      // },
      {
        label: "Deactivate ODP Access",
        isDisabled: false,
        handleQuickActionItemClick: () => {
          handleToggleDropDown();
          handleToggleDeactivateOdpAccessModal();
        },
        type: "danger",
      },
    ];
  }, [id]);

  return (
    <>
      <DropDown
        dropDownWidth={DROP_DOWN_WIDTH}
        dropDownBtnContent={
          <>
            <Box className="inline-flex gap-2 items-center w-full">
              <IconSettings className="w-4 h-4" />
              <Box
                as="span"
                className="text-sm font-semibold text-[#101828]"
              >
                More Actions
              </Box>
              <IconChevronDown className="w-4 h-4" />
            </Box>
          </>
        }
        allowOutSideClick
        customDropDownButtonCss={individualDetailsQuickActionBtnCss}
        dropDownPopUpMenuContentCss={
          moreQuickActionsDropDownPopUpMenuContentCss3
        }
        ref={dropDownRef}
      >
        <Box className="flex flex-col">
          {quickActions.map(
            ({ label, isDisabled, handleQuickActionItemClick, type }, idx) => {
              return (
                <Box
                  className={`h-10 py-[10px] flex items-center ${isDisabled ? "cursor-not-allowed" : "cursor-pointer"}`}
                  key={idx}
                  onClick={handleQuickActionItemClick}
                >
                  <Paragraph3
                    textColor={textColorMap[type]}
                    lineHeight="20px"
                    fontWeight="600"
                  >
                    {label}
                  </Paragraph3>
                </Box>
              );
            }
          )}
        </Box>
      </DropDown>
      <ResendInviteModal
        isOpen={isResendInviteModalOpen}
        setIsOpen={setIsResendInviteModalOpen}
        handleToggleResendInviteModal={handleToggleResendInviteModal}
        email={email as string}
      />
      {/* <UpdateWithdrawalCharge
        isOpen={isUpdateWithdrawalChargeModalOpen}
        setIsOpen={setIsUpdateWithdrawalChargeModalOpen}
        handleToggleUpdateWithdrawalChargeModal={
          handleToggleUpdateWithdrawalChargeModal
        }
      /> */}
      <DeactivateOdpAccess
        isOpen={isDeactivateOdpAccessModalOpen}
        setIsOpen={setIsDeactivateOdpAccessModalOpen}
        handleToggleDeactivateOdpAccessModal={
          handleToggleDeactivateOdpAccessModal
        }
        employeeId={employeeId as string}
      />
    </>
  );
};
